class CollectionsList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els?.item?.elements.forEach((itemEl) => {
      this.listeners.add(itemEl, 'mouseover', this.handleHover.bind(this))
    })

    this.els?.trigger?.elements.forEach((itemEl) => {
      this.listeners.add(itemEl, 'click', this.handleClick.bind(this))
    })
  }

  handleHover (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)
    this.updateUI(itemEl, this.els?.item?.elements)
  }

  handleClick (event) {
    const itemEl = event.target.closest(this.els?.trigger?.selector)
    this.updateUI(itemEl, this.els?.trigger?.elements)
  }

  updateUI (itemEl, elements) {
    // Set background color
    this.style.setProperty('--Background_Color', itemEl.dataset.color)

    // Handle light class
    if (itemEl.dataset.text === 'light') {
      this.classList.add('sec-CollectionsList-light')
      this.els?.button?.element.classList.add('btn-Button-white')
    } else {
      this.classList.remove('sec-CollectionsList-light')
      this.els?.button?.element.classList.remove('btn-Button-white')
    }

    // Update aria-current for the current element
    elements.forEach((el) => el.setAttribute('aria-current', false))
    itemEl.setAttribute('aria-current', true)

    // Update titles' aria-hidden attributes
    this.els?.title?.elements.forEach((titleEl) => {
      titleEl.setAttribute(
        'aria-hidden',
        itemEl.dataset.index !== titleEl.dataset.index,
      )
    })

    // Update content's aria-hidden attributes
    this.els?.content?.elements.forEach((contentEl) => {
      contentEl.setAttribute(
        'aria-hidden',
        itemEl.dataset.index !== contentEl.dataset.index,
      )
    })
  }
}

if (!customElements.get('collections-list')) {
  customElements.define('collections-list', CollectionsList)
}
